define('viewmodels/modals/dialogs/TransactionReceiptDialog',['knockout'], function (ko) {

    var TransactionReceiptDialog = function(dialog, showError, getField, getDepositField, transaction) {

        var type = ko.deferredComputed(function () {
            if (ko.unwrap(transaction.isPendingWithdraw)) {
                return 'pending_withdrawal';
            } else if (ko.unwrap(transaction.isDeposit)) {
                return 'deposit';
            } else {
                return 'withdrawal';
            }
        });

        this.transaction = transaction;
        this.dialog = dialog;

        this.receiptHeader = ko.deferredComputed(function () {
            return getField(type() + '_receipt_title')();
        });

        this.description = ko.deferredComputed(function () {
            return getField(type().replace('pending_', '') + '_description', {
                name: transaction.usableMethod.property('name'),
                identifier: transaction.usableMethod.property('identifier')
            })();
        });

        this.feeLabel = getField('fee_label');
        this.subtotalLabel = getField('subtotal_label');
        this.totalLabel = getField('total_label');
        this.cancelWithdrawalText = getField('cancel_withdrawal_cta_text');

        this.cancelledStatementText = function(selfCancelled, transaction) {
            var prefix = selfCancelled ? 'self' : 'casumo';
            return getField(prefix + '_cancelled_statement_text', {
                date: transaction.rolledBackTime.formatMoment('L')(),
                time: transaction.rolledBackTime.formatMoment('LT')()
            })();
        };

        this.cancelPendingWithdrawal = function() {
            this.transaction.cancel()
                .done(this.close.bind(this))
                .fail(function () {
                    showError(
                        getDepositField('cancelling_withdrawal_failed_error_message'),
                        getDepositField('cancelling_withdrawal_failed_error_title'));
                });
        }
    };

    TransactionReceiptDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return TransactionReceiptDialog;
});

